// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'bounding-box-solid';

export const Component = () => (
  <path d='M0 8.813V0h8.813v8.813H0Zm15.709 0V0h8.812v8.813H15.71ZM0 24.52v-8.81h8.813v8.812H0Zm15.709 0v-8.81h8.812v8.812H15.71ZM7.855 4.885v-.958h8.812v.958H7.855ZM3.927 16.667V7.855h.958v8.812h-.958Zm15.709 0V7.855h.958v8.812h-.958ZM7.855 20.594v-.958h8.812v.958H7.855Z' />
);

export const viewBox = '0 0 25 25';
